import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { type ElementRef, forwardRef, type ComponentPropsWithoutRef, useState } from 'react'
import { cn } from '#app/utils/tailwind-merge.ts'

type TooltipProps = ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>

const Tooltip = forwardRef<ElementRef<typeof TooltipPrimitive.Content>, TooltipProps>(({ content, className, children }, ref) => {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<TooltipPrimitive.Root open={isOpen} onOpenChange={setIsOpen}>
			<TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
			<TooltipPrimitive.Portal /* container={container} forceMount={forceMount} */>
				<TooltipPrimitive.Content sideOffset={4} collisionPadding={10} ref={ref} className={cn('bg-foreground px-space-5 text-size-sm text-background rounded-md', className)}>
					{content}
					<TooltipPrimitive.Arrow className="fill-tooltip-background" />
				</TooltipPrimitive.Content>
			</TooltipPrimitive.Portal>
		</TooltipPrimitive.Root>
	)
})
Tooltip.displayName = TooltipPrimitive.Content.displayName
export { Tooltip }
